import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { usePushSettings, useSetPushSetting } from "../../lib/api";
import { FieldLabel, ToggleRow } from "./primitives";

// One switch per kind of phone / computer notification. Whoever's role holds "Receive
// notifications" (Roles & access) hears about it, at the workshops their role reaches.
const EVENTS = [
  { key: "group_created", label: "Group created", hint: "A new WhatsApp group is ready." },
  { key: "sa_assigned", label: "Service advisor assigned", hint: "A booking's service advisor is changed." },
  { key: "group_auto_deleted", label: "Group auto-deleted", hint: "The timer deletes a group after delivery." },
  { key: "escalation", label: "Escalations", hint: "Every escalation: issues, ladder steps and complaints." },
];

export default function NotificationsEditor({ tenantId }) {
  const { data, isLoading } = usePushSettings(tenantId);
  const save = useSetPushSetting(tenantId);

  const onChange = async (event, enabled) => {
    try {
      await save.mutateAsync({ event, enabled });
      toast.success("Notification setting saved.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed.");
    }
  };

  if (isLoading) {
    return (
      <div className="mt-7 flex items-center gap-2 text-[13px] text-[#6B7280]">
        <Loader2 className="animate-spin" size={15} /> Loading
      </div>
    );
  }

  return (
    <div className="mt-7 flex max-w-[640px] flex-col gap-2">
      <FieldLabel>Send a notification when</FieldLabel>
      {EVENTS.map(({ key, label, hint }) => (
        <ToggleRow
          key={key}
          title={label}
          status={hint}
          checked={data?.[key] !== false}
          disabled={save.isPending}
          onChange={(v) => onChange(key, v)}
        />
      ))}
    </div>
  );
}
